import { render, staticRenderFns } from "./delete-assessment.vue?vue&type=template&id=df6b67e6"
import script from "./delete-assessment.vue?vue&type=script&lang=js"
export * from "./delete-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports